import { createSelector } from 'reselect'
import { isBoolean } from 'lodash'
import { selectFromHomeData } from 'src/store/selectors/home'
import { getThe, getFrom } from 'src/store/selectors/utils'

export const getHomeAnswers = getThe('answers')
const getFromAnswers = getFrom(getHomeAnswers)
export const getIsHomePaidInFull = getFromAnswers('isHomePaidInFull')

const selectIsHomePaidInFull = selectFromHomeData(getIsHomePaidInFull)
export const selectPaidInFull = createSelector(
  selectIsHomePaidInFull,
  isHomePaidInFull =>
    isBoolean(isHomePaidInFull) ? isHomePaidInFull : isHomePaidInFull === 'true'
)
